import { ReactComponent as IconSvg } from './icon_arrow_left.svg';
import Icon, { IconProps } from './icon';

const IconArrowLeft = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconArrowLeft;
